import React from "react";
import LegalLayout, { Section } from "./LegalLayout";

export default function ImpressumPage() {
  return (
    <LegalLayout title="Impressum" lastUpdated="16.05.2026" testId="impressum-page">
      <Section title="Angaben gemäß § 5 ECG / § 24 MedienG">
        <p>
          <strong>StudioOps</strong>
          <br />
          Silverio Cosenza
          <br />
          Amalienstraße 57/16
          <br />
          1130 Wien, Österreich
        </p>
      </Section>

      <Section title="Kontakt">
        <p>
          E-Mail:{" "}
          <a href="mailto:hello@studioops.io" className="text-brand hover:underline">
            hello@studioops.io
          </a>
        </p>
      </Section>

      <Section title="Unternehmensdaten">
        <p>
          UID-Nummer: <span className="text-ink-muted">[Platzhalter]</span>
          <br />
          Unternehmensgegenstand: SaaS-Plattform für F&amp;B-Kostenkalkulation
          und KI-Rezeptgenerierung
        </p>
      </Section>

      <Section title="Aufsichtsbehörde / Gewerbebehörde">
        <p>Magistratisches Bezirksamt für den 13. Bezirk, Wien</p>
      </Section>

      <Section title="Anwendbare Rechtsvorschriften">
        <p>
          Gewerbeordnung: <span className="text-brand">www.ris.bka.gv.at</span>
        </p>
      </Section>

      <Section title="Online-Streitbeilegung (OS)">
        <p>
          Die Europäische Kommission stellt eine Plattform zur
          Online-Streitbeilegung (OS) bereit:{" "}
          <a
            href="https://ec.europa.eu/consumers/odr"
            target="_blank"
            rel="noopener noreferrer"
            className="text-brand hover:underline"
          >
            https://ec.europa.eu/consumers/odr
          </a>
          . Wir sind weder bereit noch verpflichtet, an Streitbeilegungsverfahren
          vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </Section>

      <Section title="Haftungsausschluss">
        <p>
          Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung
          für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten
          sind ausschließlich deren Betreiber verantwortlich.
        </p>
      </Section>

      <Section title="Urheberrecht">
        <p>
          Sämtliche Inhalte dieser Website (Texte, Bilder, Grafiken, Logos)
          unterliegen dem Urheberrecht. Jede Verwertung außerhalb der engen
          Grenzen des Urheberrechtsgesetzes bedarf der schriftlichen Zustimmung
          von StudioOps.
        </p>
      </Section>
    </LegalLayout>
  );
}
